// extracted by mini-css-extract-plugin
module.exports =  {"root":"vUDE3OeUtU7AhBB4rrbb","content":"g9iKPsi4tC4A_dUC0Kgn","labelContainer":"ZoIfPHrafubmDEPAP98R","label":"fIrZINS6FzLLQE1UiroZ"};